import React, { useState, useEffect } from 'react';
import compose from 'lodash/fp/compose';
import withAddQuestion from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/question';
import { withMetrics } from '@catalogo/core-metrics';
import { useLazyCronometer } from '../../utils/cronometer';
import { errorsFeedback } from '../../utils/errors-feedback';
import { formatErrorMessage } from '../../utils/format-error';

export const withFeedback = Component => props => {
  const [timer, start, isStarted] = useLazyCronometer(60);
  const [error, setError] = useState({ status: false });
  const [isSuccess, setIsSuccess] = useState(false);
  const [timerFinished, setTimerFinished] = useState(false);
  const [loading, setLoading] = useState(false);
  const { addQuestion, text, qnaFaqUrl, dispatchMetrics } = props;
  const isWordCountReached = !!text.length && text.trim().split(' ').length >= 2;

  const metricError = () => {
    dispatchMetrics('event:track', {
      category: 'qna-pdp',
      action: 'enviar-pergunta',
      label: 'erro',
    });
  };

  useEffect(() => {
    setError({ status: false });
  }, [text]);
  useEffect(() => {
    if (error.statusCode === 429) {
      start();
    }
  }, [error.statusCode]);
  useEffect(() => {
    timer &&
      isStarted &&
      setError({
        ...error,
        title: errorsFeedback.timeoutRuning,
        message: `Aguarde ${timer}s pra perguntar de novo ;)`,
      });
    !timer && setError({ status: false });
    !timer && setTimerFinished(true);
  }, [timer]);

  const onSubmit = async text => {
    setLoading(true);
    if (!isWordCountReached) {
      setError({ message: errorsFeedback.wordCountReached, status: true });
      setLoading(false);
      metricError();

      return;
    }

    const { result, loading } = await addQuestion(text);
    setLoading(loading);

    if (result?.data?.addQuestion?.validationErrors === null) {
      setIsSuccess(true);
      setError({ status: false });

      return;
    }

    const errorResult = await formatErrorMessage(result, qnaFaqUrl);
    metricError();
    setError(errorResult);
  };

  return (
    <Component
      {...props}
      onSubmit={onSubmit}
      isSuccess={isSuccess}
      error={error}
      loading={loading}
      timerFinished={timerFinished}
    />
  );
};

export default compose(withAddQuestion, withMetrics, withFeedback);
